/**
 * Forms domain register
 *
 * Phase-4 lifecycle pattern: sync `registerForms()` for module wiring,
 * async `initializeForms()` and `disposeForms()` for the connector.
 */
import { logger } from "../../lib/logger";
import { formSubmissionConnector } from "./mycelium-form-submission.connector";

export function registerForms(): void {
  logger.debug("Forms domain registered");
}

export async function initializeForms(): Promise<void> {
  try {
    await formSubmissionConnector.initialize();
  } catch (err) {
    logger.error("Forms domain initialization failed", { error: err });
    throw err;
  }
}

export async function disposeForms(): Promise<void> {
  try {
    await formSubmissionConnector.dispose();
  } catch (err) {
    logger.error("Forms domain dispose failed", { error: err });
  }
}

export { formSubmissionConnector };
